import { render, staticRenderFns } from "./Motor.vue?vue&type=template&id=577fcd32&"
import script from "./Motor.vue?vue&type=script&lang=ts&"
export * from "./Motor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577fcd32')) {
      api.createRecord('577fcd32', component.options)
    } else {
      api.reload('577fcd32', component.options)
    }
    module.hot.accept("./Motor.vue?vue&type=template&id=577fcd32&", function () {
      api.rerender('577fcd32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/Motor.vue"
export default component.exports